import moment from 'moment'
import { DateFormatMoment, formatMomentLong, formatMomentShort } from 'utils/date'

import { ITimestampJSON } from '../domain/TransportPlanTimestamp'

const FORMAT_MONTH_YEAR = 'MMM YYYY' // Jan 2018

export const formatMoment = (date: string | Date, useShortDate: boolean = false) =>
  // return original if date is YYYY-MM-DD (10 symbols)
  useShortDate || (typeof date === 'string' && date.length === 10) ? formatMomentShort(date) : formatMomentLong(date)

export const formatDatesRangeString = (
  date1: Date | string,
  date2: Date | string,
  useShortDate: boolean = false
): string | [string, string] => {
  const m1 = moment(date1)
  const m2 = moment(date2)
  const isSameDay = m1.isSame(m2, 'day')
  if (isSameDay) {
    const t1 = m1.format(DateFormatMoment.TIME)
    const t2 = m2.format(DateFormatMoment.TIME)
    const date = formatMomentShort(m1)
    return useShortDate ? date : `${date} ${t1} - ${t2}`
  }
  const isSameMonth = m1.isSame(m2, 'month')
  if (isSameMonth) {
    const d1 = m1.format('DD')
    const d2 = m2.format('DD')
    const date = m1.format(FORMAT_MONTH_YEAR)
    return `${d1} - ${d2}. ${date}`
  }
  return useShortDate ? [formatMomentShort(m1), formatMomentShort(m2)] : [formatMomentLong(m1), formatMomentLong(m2)]
}

export const formatTpTimestampToString = (
  translate: (term: string) => void,
  timestamp: ITimestampJSON,
  useShortDate: boolean = false
): string => {
  const isInterval = typeof timestamp.interval === 'number' && timestamp.interval > 0

  const dateString = formatTimestampToString(timestamp, useShortDate)

  let intervalStr = ''
  if (isInterval) {
    const workingDays = translate('shipment_details-containers-pdad-working_days')
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- TODO: Fix template expression
    intervalStr = `  +/- ${timestamp.interval} ${workingDays}`
  }

  return dateString + intervalStr
}

export const formatTimestampToString = (timestamp: ITimestampJSON, useShortDate: boolean = false) => {
  return timestamp.toDate
    ? getDateRangeString(timestamp.date, timestamp.toDate)
    : formatMoment(timestamp.date, useShortDate)
}

const getDateRangeString = (date1, date2) => {
  const momentDate1 = moment(date1)
  const momentDate2 = moment(date2)
  const diffDays = momentDate1.diff(momentDate2, 'days')
  if (diffDays === 0) {
    return `${formatMomentShort(momentDate1)} ${momentDate1.format(DateFormatMoment.TIME)} – ${momentDate2.format(DateFormatMoment.TIME)}`
  }
  return `${formatMomentLong(date1)} – ${formatMomentLong(date2)}`
}
